import React from "react";
import { Grid, Typography, Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CTBox, StyledGrid, StyledH3Heading } from "../style/StyledComponents";

const qAndA = [
  {
    q: `Is clipThoughts' storing your data?`,
    a: `We do not store any of your information, including videos, notes, and bookmarks. All data is stored locally in your browser's storage. If you delete your browser history, you will lose this data. Therefore, we recommend saving your data in ClipThoughts' JSON format, which you can later upload using the load button.`
  },
  {
    q: `How do I save bookmark and notes?`,
    a: `We highly recommend that you save your bookmark and notes. You can save bookmark in ClipThoughts's json format by clicking on the save button on video page. You can load your bookmarks and notes by clicking on the load button next to the submit button. Other than that you can also export in different format such as MarkDown, TXT and PDF.`
  },
  {
    q: `Is URL shareable?`,
    a: `Yes, you can click on the share link button to generate shareable URL. We encode your bookmarks within the URL, allowing anyone with the shared link to access the notes and timestamps associated with the video.`
  },
  {
    q: `What are some Keyboard shortcuts?`,
    a: (
      <ul>
        <li><Typography variant="body1"><strong>Space</strong>: Start or Play (Use left arrow/right arrow key to change tabs and press space to play that section) </Typography></li>
        <li><Typography variant="body1"><strong>o</strong>: Loop</Typography></li>
        <li><Typography variant="body1"><strong>Left Arrow</strong>: Move Tab Backward</Typography></li>
        <li><Typography variant="body1"><strong>Right Arrow</strong>: Move Tab Forward</Typography></li>
        <li><Typography variant="body1"><strong>h</strong>: Step Backward by 1 second</Typography></li>
        <li><Typography variant="body1"><strong>l</strong>: Step Forward by 1 second</Typography></li>
      </ul>
    )
  }
]

const FaqSection = () => {
  return (
    <>
    <CTBox sx={{padding: "2rem"}}>
      <StyledH3Heading>FAQ</StyledH3Heading>
      <StyledGrid container spacing={2}>
        {qAndA.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
              <Typography variant="body1">{item.q}</Typography>
              </AccordionSummary>
              <AccordionDetails>{item.a}</AccordionDetails>
            </Accordion>
          </Grid>
        ))}
      </StyledGrid>
    </CTBox>
    </>
  );
}

export default FaqSection;